<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/6chap1#chap1">Prologue</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/7chap2#chap2">Part 1: City of Dreams</a></p>
<p class="toc2"><a href="#/8chap3#chap3">Chapter 1</a></p>
<p class="toc2"><a href="#/9chap4#chap4">Chapter 2</a></p>
<p class="toc2"><a href="#/10chap5#chap5">Chapter 3</a></p>
<p class="toc2"><a href="#/11chap6#chap6">Chapter 4</a></p>
<p class="toc2"><a href="#/12chap7#chap7">Chapter 5</a></p>
<p class="toc2"><a href="#/13chap8#chap8">Chapter 6</a></p>
<p class="toc2"><a href="#/14chap9#chap9">Chapter 7</a></p>
<p class="toc2"><a href="#/15chap10#chap10">Chapter 8</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/16chap11#chap11">Part 2: The Mystery and Melancholy of a Street</a></p>
<p class="toc2"><a href="#/17chap12#chap12">Chapter 9</a></p>
<p class="toc2"><a href="#/18chap13#chap13">Chapter 10</a></p>
<p class="toc2"><a href="#/19chap14#chap14">Chapter 11</a></p>
<p class="toc2"><a href="#/20chap15#chap15">Chapter 12</a></p>
<p class="toc2"><a href="#/21chap16#chap16">Chapter 13</a></p>
<p class="toc2"><a href="#/22chap17#chap17">Chapter 14</a></p>
<p class="toc2"><a href="#/23chap18#chap18">Chapter 15</a></p>
<p class="toc2"><a href="#/24chap19#chap19">Chapter 16</a></p>
<p class="toc2"><a href="#/25chap20#chap20">Chapter 17</a></p>
<p class="toc2"><a href="#/26chap21#chap21">Chapter 18</a></p>
<p class="toc2"><a href="#/27chap22#chap22">Chapter 19</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/28chap23#chap23">Part 3: Art in the War Zone</a></p>
<p class="toc2"><a href="#/29chap24#chap24">Chapter 20</a></p>
<p class="toc2"><a href="#/30chap25#chap25">Chapter 21</a></p>
<p class="toc2"><a href="#/31chap26#chap26">Chapter 22</a></p>
<p class="toc2"><a href="#/32chap27#chap27">Chapter 23</a></p>
<p class="toc2"><a href="#/33chap28#chap28">Chapter 24</a></p>
<p class="toc2"><a href="#/34chap29#chap29">Chapter 25</a></p>
<p class="toc2"><a href="#/35chap30#chap30">Chapter 26</a></p>
<p class="toc2"><a href="#/36chap31#chap31">Chapter 27</a></p>
<p class="toc2"><a href="#/37chap32#chap32">Chapter 28</a></p>
<p class="toc2"><a href="#/38chap33#chap33">Epilogue</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/39chap34#chap34">Acknowledgments</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/40about#about">About the Author</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-TOC.vue?c9b316b2